import styled from 'styled-components';

export const Container = styled.div`
  border: 3px solid #cce6ee;
  padding: 20px;
  margin-bottom: 30px;

  span {
    color: #0384ac;
  }

  .icon-options {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const QuantityText = styled.p`
  font-weight: bold;
  font-size: 14px;
  color: #0384ac;
  margin-left: 10px;
`;

export const Text = styled.p`
  ${(props) =>
    props.bold &&
    `
    font-weight: bold;
  `}
  font-size: 14px;
  color: #0384ac;
`;

export const Ampoules = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 14.36px);
  grid-gap: 5px;
  justify-content: space-between;

  .icon-ampoule {
    font-size: 34px;
  }

  .used {
    color: #cce6ee;
  }
`;
